import * as React from 'react';

import AssessmentResult from '../../containers/AssessmentResult';
import Navbar from '../../containers/NavbarAdmin';
import i18n from '../../resources/i18n';
/**
 * アセスメント結果表示画面
 * @param props
 */
const TestResult: React.FC<any> = props => {
	return (
		<>
			<Navbar title={i18n.t('AssessmentResultAdmin_0001')} />
			<AssessmentResult
				careerId={props.match.params.career_id}
				classId={props.match.params.class_id}
				rankId={props.match.params.rank_id}
				adminView={true}
				targetuserId={props.match.params.user_id}
			/>
		</>
	);
};

export default TestResult;



// WEBPACK FOOTER //
// ./src/pages/personal/AssessmentResultAdmin.tsx